<template>
  <section>
    <b-modal size="lg" :id="modalId" :ref="modalId"
             @show="resetModal(true)"
             @ok="saveTask"
             :ok-title="isSaving ? 'Saving...' : 'Save'"
             :ok-disabled="isSaving"
             title="Add/Edit Task"
             no-close-on-backdrop
    >
      <b-row class="mb-2">
        <b-col>
          <b-form-group label="Subject" class="required">
            <b-form-input v-model="formData.subject" :class="{ 'is-invalid': $v.formData.subject.$error }"/>
            <b-form-invalid-feedback>Please enter task subject</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col>
          <b-form-group label="Description">
            <b-form-textarea v-model="formData.description" rows="3"/>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col cols="4">
          <b-form-group label="Company" class="required">
            <b-input-group size="sm">
              <b-input-group-append v-if="checkClaim(CAN_ADD_COMPANY) || checkClaim(CAN_EDIT_COMPANY)">
                <b-button variant="light" @click="$refs.addNewCompany.showModal()">
                  <i v-if="checkClaim(CAN_ADD_COMPANY)" v-show="this.formData.companyId == undefined || this.formData.companyId == null || this.formData.companyId == 0" class="customer-lookup--plus fa fa-plus"></i>
                  <i v-if="checkClaim(CAN_EDIT_COMPANY)" v-show="this.formData.companyId > 0" class="customer-lookup--plus fa fa-pencil"></i>
                </b-button>
              </b-input-group-append>
              <vue-simple-suggest
                class="suggest-input form-control"
                :class="{ 'is-invalid': $v.formData.companyId.$error }"
                :styles="autoCompleteStyle"
                :list="getListOfNames"
                :max-suggestions="20"
                :min-length="3"
                :debounce="200"
                :filter-by-query="true"
                value-attribute="id"
                display-attribute="name"
                v-model="chosenName"
                @select="onSuggestNameSelect"
                @input="suggestNameChange"
                @blur="onCompanyBlur"
                @request-done="onRequestDone"
                :disabled="(fromCompanyPage || fromContactsPage) && editDetails && (editDetails.companyId>0)"
              >
                <div slot="misc-item-below" v-if="isLoading" class="misc-item">
                  <span>Loading companies...</span>
                </div>
              </vue-simple-suggest>
              <b-form-invalid-feedback v-show="$v.formData.companyId.$error">Please select company
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group label="Contact" class="required">
            <b-input-group size="sm">
              <b-input-group-append v-if="checkClaim(CAN_EDIT_COMPANY) && this.formData.companyId">
                <b-button variant="light" @click="$refs.addNewContact.newContact()">
                  <i v-show="this.formData.contactId == undefined || this.formData.contactId == null || this.formData.contactId == 0" class="customer-lookup--plus fa fa-plus"></i>
                  <i v-show="this.formData.contactId > 0" class="customer-lookup--plus fa fa-pencil"></i>
                </b-button>
              </b-input-group-append>
              <b-form-select v-model="formData.contactId" :class="{ 'is-invalid': $v.formData.contactId.$error }">
                <option v-for="(select, index) in sortSelect(contacts,'firstName')" :key="index" :value="select.id">
                  {{ select.firstName + ' ' + select.lastName }}
                </option>
              </b-form-select>
              <b-form-invalid-feedback>Please select contact person</b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group label="Type" class="required">
            <b-form-select v-model="formData.taskTypeId" :class="{ 'is-invalid': $v.formData.taskTypeId.$error }">
              <option v-for="(select, index) in sortSelect(taskTypes)" :key="index" :value="select.id">
                {{ select.name }}
              </option>
            </b-form-select>
            <b-form-invalid-feedback>Please select task type</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col cols="3">
          <b-form-group label="Assigned To" class="required">
            <b-form-select v-model="formData.assignedToUserId" :disabled="!checkClaim(CAN_MANAGE_TASKS)"
                           :class="{ 'is-invalid': $v.formData.assignedToUserId.$error }">
              <option v-for="(select, index) in sortSelect(getAllUser,'fullName')" :key="index" :value="select.id">
                {{ select.fullName }}
              </option>
            </b-form-select>
            <b-form-invalid-feedback>Select assigned to user</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group label="Priority">
            <b-form-radio-group
              :class="{ 'is-invalid': $v.formData.taskPriorityId.$error }"
              v-model="formData.taskPriorityId"
              :options="taskPriority"
            ></b-form-radio-group>
            <b-form-invalid-feedback>Please select task priority</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col>
          <b-row>
            <b-form-group label="Due" class="required mr-2" style="width: 100px">
              <date-picker v-model="formData.taskDue" :config="datePickerOptions" size="sm"
                          :class="{ 'is-invalid': $v.formData.taskDue.$error }"/>
              <b-form-invalid-feedback>Please select task due date</b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label=" " class="mr-2" style="width:60px; margin-top: 17px">
              <b-form-select v-model="formData.taskDueHour">
                <option v-for="(n,index) in 12" :key="index" :value="n">
                  {{ (n).toLocaleString('en', {minimumIntegerDigits:2,useGrouping:false}) }}
                </option>
              </b-form-select>
            </b-form-group>
            <b-form-group label=" " class="mr-2" style="width:60px; margin-top: 17px">
              <b-form-select v-model="formData.taskDueMinute">
                <option value="0">00</option>
                <option v-for="(n,index) in 3" :key="index" :value="n*15">
                  {{ (n*15).toLocaleString('en', {minimumIntegerDigits:2,useGrouping:false}) }}
                </option>
              </b-form-select>
            </b-form-group>
            <b-form-group label=" " class="mr-2" style="width:60px; margin-top: 17px">
              <b-form-select v-model="formData.taskDueAmPm">
                <option value="AM">AM</option>
                <option value="PM">PM</option>
              </b-form-select>
            </b-form-group>  
          </b-row>
          
        </b-col>
      </b-row>
    </b-modal>
    <edit-company
      modalId="edit-company-from-task"
      ref="addNewCompany"
      hiddenButton
      :id="this.formData.companyId"
      @currentCompany="onCurrentCompany"
      @cancel="chosenName = ''"
    />
    <company-contact ref="addNewContact" :companyId="this.formData.companyId" :id="this.formData.contactId" @created="onContactCreated" />
  </section>
</template>

<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex';
  import VueSimpleSuggest from 'vue-simple-suggest';
  import { required } from 'vuelidate/lib/validators';
  import { DATE_FORMAT, AUTO_COMPLETE_STYLES, TODO_TASK_TYPES } from '@/shared/constants';
  import EditCompany from '@/pages/Company/components/EditCompany';
  import CompanyContact from '@/shared/components/CompanyContact';
  import { date } from '@/shared/filters';
  import { roleMixin } from '@/shared/helpers';
  export default {
    components: {
      VueSimpleSuggest,
      EditCompany,
      CompanyContact,
    },
    props: {
      editDetails: {
        type: Object,
        default: () => {
        },
      },fromCompanyPage: {
        type: Boolean,
        default: false,
      },
      fromContactsPage: {
        type: Boolean,
        default: false,
      },
      modalId: {
        type: String,
        default: 'add-task-modal'
      }
    },
    data() {
      return {
        dateFilter: date,
        formData: {
          id: 0,
          taskTypeId: '',
          taskStatusId: 410,
          companyId: '',
          contactId: '',
          // assignedToUserId: (!roleMixin.methods.checkClaim(roleMixin.data().CAN_MANAGE_TASKS)) ? this.userId : '',
          assignedToUserId: '',
          taskDue: new Date(),
          taskDueHour: '1',
          taskDueMinute: '0',
          taskDueAmPm: 'AM',
          taskPriorityId: 419,
          subject: '',
          description: '',
          notes: '',
          active: true,
        },
        chosenName: '',
        autoCompleteStyle: AUTO_COMPLETE_STYLES,
        datePickerOptions: {
          format: DATE_FORMAT,
          useCurrent: true,
        },
        isLoading: false,
        isSaving: false,
        taskTypes: TODO_TASK_TYPES,
        taskPriority: [
          { value: 418, text: 'High' },
          { value: 419, text: 'Normal' },
          { value: 420, text: 'Low' },
        ],
      };
    },
    validations: {
      formData: {
        taskTypeId: { required },
        companyId: { required },
        contactId: { required },
        assignedToUserId: { required },
        taskDue: { required },
        subject: { required },
        taskPriorityId: { required },
      },
    },
    computed: {
      // ...mapGetters('quoteAdd', [
      //   'customers',
      //   'vendors',
      //   'contacts',
      // ]),

      ...mapGetters('quoteAdd', [
        'contacts',
      ]),

      ...mapGetters('account', ['userId']),
      ...mapGetters('users', [
        'getAllUser',
      ]),
    },
    methods: {
      ...mapActions('companies', ['getByNameAndAccountType']),
      ...mapActions('users', ['getAll']),
      ...mapActions('todotasks', ['manageTask']),
      // ...mapActions('quoteAdd', [
      //   'getCustomers',
      //   'getContacts',
      //   'clearContacts',
      // ]),

      ...mapActions('quoteAdd', [
        'getContacts',
      ]),
      ...mapMutations('quoteAdd', {quoteAddSetItem: 'setItem'}),
      async onSuggestNameSelect(suggestion) {
        this.formData.companyId = suggestion.id;
        await this.getContacts(suggestion.id);
      },
      async suggestNameChange(val) {
        this.isLoading = true;
        if (val === '' || val !== this.chosenName) {
          this.formData.companyId = '';
          this.formData.contactId = '';
          // this.clearContacts();
          this.quoteAddSetItem({ resource: 'contacts', payload: [] });
        }
      },
      async getListOfNames(name) {
        return this.getByNameAndAccountType({typeId: 0, name});
      },
      async onCompanyBlur() {
        if(this.chosenName && !this.formData.companyId && !this.isLoading) {
          const deleteConfirmed = await this.openConfirmBox({
            message: `${this.chosenName} is not in the database. Press Continue to add them.`,
            okTitle: 'Continue',
          });
          if (deleteConfirmed) {
            this.$refs.addNewCompany.showModal();
          } else {
            this.chosenName = "";
          }
        }
      },
      async resetModal(getData = false) {
        this.$v.$reset();
        // this.clearContacts();
        if (getData) {
          if (this.editDetails !== undefined) {
            //this.setFormData(this.editDetails);
          }
          await this.getAll();
        }
      },
      onRequestDone() {
        this.isLoading = false;
      },
      async saveTask(e) {
        e.preventDefault();
        this.$v.formData.$touch();
        if (this.$v.formData.$invalid) {
          return;
        }
        this.formData.taskDue = new Date(this.formData.taskDue).toISOString();
        // this.formData.assignedToUserId = (!roleMixin.methods.checkClaim(roleMixin.data().CAN_MANAGE_TASKS)) ? this.userId : this.formData.assignedToUserId;
        try {
          this.isSaving = true;
          await this.manageTask(this.formData);
          this.$bvModal.hide(this.modalId);
          this.resetModal();
          this.$emit('refreshGrid');
          this.isSaving = false;
        }catch (e) {
          this.isSaving = false;
        }
      },
      async onCurrentCompany(val) {
        this.chosenName = val.name;
        this.formData.companyId = val.id;
        this.getContacts(val.id);
      },
      async onContactCreated(id) {
        this.formData.contactId = id;
        this.getContacts(this.formData.companyId);
      },
      setFormData(editDetails) {
        this.formData = {
          id: editDetails.id || 0,
          taskTypeId: editDetails.taskTypeId || '',
          taskStatusId: editDetails.taskStatusId || 410,
          companyId: editDetails.companyId || '',
          contactId: editDetails.contactId || '',
          // assignedToUserId: editDetails.assignedToUserId || (!roleMixin.methods.checkClaim(roleMixin.data().CAN_MANAGE_TASKS)) ? this.userId : '',
          assignedToUserId: editDetails.assignedToUserId || '',
          taskDue: (editDetails.taskDue) ? this.dateFilter(editDetails.taskDue) : new Date(),
          taskDueHour: editDetails.taskDueHour || 1,
          taskDueMinute: editDetails.taskDueMinute || 0,
          taskDueAmPm: editDetails.taskDueAmPm || 'AM',
          taskPriorityId: editDetails.taskPriorityId || 419,
          subject: editDetails.subject,
          description: editDetails.description || '',
          notes: editDetails.notes || '',
          active: true,
        };

        if (this.formData.companyId) {
          this.chosenName = editDetails.companyName;
          this.getContacts(this.formData.companyId);
          this.onSuggestNameSelect({ id: editDetails.companyId });
        } else {
          this.chosenName = '';
          // this.clearContacts();
          this.quoteAddSetItem({ resource: 'contacts', payload: [] });
        }
      },
    },
    watch: {
      editDetails() {

        console.log('editDetails :', this.editDetails);

        this.setFormData(this.editDetails);
      },
    },
    async mounted() {

    },
  };
</script>
